import { render } from "./StepEmpty.vue?vue&type=template&id=532c0aca&scoped=true&bindings={}"
import script from "./StepEmpty.vue?vue&type=script&lang=ts"
export * from "./StepEmpty.vue?vue&type=script&lang=ts"

import "./StepEmpty.vue?vue&type=style&index=0&id=532c0aca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-532c0aca"

export default script